import { IUser } from 'src/app/common/model/user.model';
import {
  ITransaction,
  ITransactionHeader
} from '../../EBMSuite/models/transaction.model';
import { IMember } from './members.model';

export enum AccountType {
  ORGANIZATION = 'ORGANIZATION',
  INDIVIDUAL = 'INDIVIDUAL'
}
export enum EContactType {
  CUSTOMER = 'CUSTOMER',
  VENDOR = 'VENDOR',
  INSURER = 'INSURER',
  LEAD = 'LEAD'
}
export interface IContact {
  _id?: string;
  name: string;
  email?: string;
  phoneNumber?: number;
  address?: string;
  city?: string;
  postalCode?: number;
  contactType?: AccountType;
  posContactType?: EContactType;
  transactions?: ITransaction[];
  keyContacts?: IContact[];
  twitter?: string;
  messenger?: string;
  menuItems?: any[];
  status?: ELeadStatus;
  top?: boolean;
  reportingOfficer?: IContact; // move to employee details model
  employeeDetails: IEmployee;
  user?: IUser;
  organizationMemberId?: string; //linked org member
  assignedTo?: IMember[]; //linked org member
  linkedTo?: IContact; //linked other contact
  createdFrom?: IContact; //contact created from(lead to customer)

  notes: any;
}

export interface IEmployee {
  employeeNumber?: number;
  reportingOfficer?: IContact;
  bankAccNumber?: number;
  bankName?: string;
  department?: string;
  gender?: EGender;
  idNumber?: number | string;
  idType?: number | string;
  taxRegNo?: string;
  position?: any;
  sLocation?: any;
  nextOfKin?: any;
  startDate?: string;
  status?: string;
  bankCode?: string;
  isOnLeave?: boolean;
  employeeType?: string;
  departmentId?: string;
  basePay?: number;
  deductionsAmount?: number;
  benefitsAmount?: number;
  additionsAmount?: number;
  totalPay?: number;
  isActive?: boolean;
}
export interface ILead {
  _id?: string;
  name: string;
  email?: string;
  phoneNumber?: number;
  address?: string;
  city?: string;
  postalCode?: number;
  contact?: IContact;
  twitter?: string;
  messenger?: string;
  title: string;
  notes: any[];
  status?: ELeadStatus;
  contactType?: AccountType;
  type: ELeadType;
  leadDisqualificationReason?: string;
  menuItems?: any[];
}

export enum ELeadStatus {
  DISQUALIFIED = 'DISQUALIFIED',
  QUALIFIED = 'QUALIFIED'
}

export enum ELeadType {
  LEAD = 'LEAD',
  OPPORTUNITY = 'OPPORTUNITY',
  CLIENT = 'CLIENT'
}

export interface IContactNote {
  _id?: string;
  title: string;
  description: string;
  menuItems: any[];
  createdBy: IUser;
  createdAt: Date;
}

export interface IContactTasks {
  unFulfilledTransactions: ITransactionHeader[];
  pendingBalances: ITransactionHeader[];
}

export enum EGender {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  PREFER_NOT_TO_SAY = 'PREFER_NOT_TO_SAY',
  OTHER = 'OTHER'
}
